import { render, staticRenderFns } from "./Reservas.vue?vue&type=template&id=d1225de0&scoped=true&xmlns%3Av-slot=http%3A%2F%2Fwww.w3.org%2F1999%2FXSL%2FTransform&"
import script from "./Reservas.vue?vue&type=script&lang=js&"
export * from "./Reservas.vue?vue&type=script&lang=js&"
import style0 from "./Reservas.vue?vue&type=style&index=0&id=d1225de0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d1225de0",
  null
  
)

export default component.exports